import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatRadioChange } from '@angular/material/radio';
import { RequestFormService } from '../../service/requestForm/request-form.service';

@Component({
  selector: 'app-custom-radio-button',
  templateUrl: './custom-radio-button.component.html',
  styleUrls: ['./custom-radio-button.component.scss'],
})
export class CustomRadioButtonComponent {
  @Input() name!: any;
  @Input() options: { label: string; value: string ; disabled?: boolean}[] = [];
  @Input() controlname: FormControl | any;
  selectedOption!: any;
  @Input() form!: FormGroup;
  @Output() onInput = new EventEmitter<Event>();
  @Input() formSubmitted!: boolean;
  @Input() disabled: boolean = false;
  @Input() errorMessage: string = 'Please select an option';
   constructor(private requestFormService: RequestFormService) {}
  get formControl() {
    return this.form.get(this.controlname);
  }
    isDarkMode() {
    return this.requestFormService.isDarkMode();
  }
}
